module.exports = __webpack_public_path__ + "media/images/integrated-payments-4-605e4ea097895582d6e873c2441b68ce.svg";